import { render, staticRenderFns } from "./indexStudentTitleCard.vue?vue&type=template&id=050e1b72&scoped=true&"
import script from "./indexStudentTitleCard.vue?vue&type=script&lang=js&"
export * from "./indexStudentTitleCard.vue?vue&type=script&lang=js&"
import style0 from "./indexStudentTitleCard.vue?vue&type=style&index=0&id=050e1b72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e1b72",
  null
  
)

export default component.exports